import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Table from "../../core/common/dataTable/index";
import { McitiImg } from "../../utils/iconLogo";

const ViewAttendance = () => {
  const columns = [
    { title: "S.No.", dataIndex: "Sno" },
    { title: "Date", dataIndex: "Date" },
    { title: "Name", dataIndex: "Name" },
    { title: "Participant Type", dataIndex: "ParticipantType" },
    { title: "Participant Tier", dataIndex: "ParticipantTier" },
    { title: "Course Group", dataIndex: "CourseGroup" },
    { title: "Batch No.", dataIndex: "BatchNo" },
    { title: "Admn No", dataIndex: "AdmnNo" },
    { title: "Academic Year", dataIndex: "AcademicYear" },
    { title: "Semester", dataIndex: "Semester" },
    { title: "Status", dataIndex: "Status" },
    {
      title: "Change",
      dataIndex: "Change",
      render: (value: string, record: any, index: number) => (
        <select
          // value={value}
          // onChange={(e) => handleChangeStatus(e.target.value, index)}
          className="form-select"
          style={{
            width: "90px",
            padding: "4px 8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
          }}
        >
          <option value="Present">Present</option>
          <option value="Absent">Absent</option>
        </select>
      ),
    },
  ];

  const tableData = [
    {
      Sno: 1,
      Date: "2025-07-03",
      Name: "RAVI KUMAR",
      ParticipantType: "SCHOOL TEACHERS",
      ParticipantTier: "PGT CS",
      CourseGroup: "ML",
      BatchNo: "A",
      AdmnNo: "2506240022",
      AcademicYear: "2024",
      Semester: "I",
      Status: "Absent",
      Change: "Absent",
    },
    {
      Sno: 2,
      Date: "2025-06-25",
      Name: "RAVI KUMAR",
      ParticipantType: "SCHOOL TEACHERS",
      ParticipantTier: "PGT CS",
      CourseGroup: "ML",
      BatchNo: "A",
      AdmnNo: "2506240022",
      AcademicYear: "2024",
      Semester: "I",
      Status: "Present",
      Change: "Present",
    },
    {
      Sno: 3,
      Date: "2025-06-26",
      Name: "RAVI KUMAR",
      ParticipantType: "SCHOOL TEACHERS",
      ParticipantTier: "PGT CS",
      CourseGroup: "ML",
      BatchNo: "A",
      AdmnNo: "2506240022",
      AcademicYear: "2024",
      Semester: "I",
      Status: "Present",
      Change: "Present",
    },
    {
      Sno: 4,
      Date: "2025-06-27",
      Name: "RAVI KUMAR",
      ParticipantType: "SCHOOL TEACHERS",
      ParticipantTier: "PGT CS",
      CourseGroup: "ML",
      BatchNo: "A",
      AdmnNo: "2506240022",
      AcademicYear: "2024",
      Semester: "I",
      Status: "Present",
      Change: "Present",
    },
    {
      Sno: 5,
      Date: "2025-06-28",
      Name: "RAVI KUMAR",
      ParticipantType: "SCHOOL TEACHERS",
      ParticipantTier: "PGT CS",
      CourseGroup: "ML",
      BatchNo: "A",
      AdmnNo: "2506240022",
      AcademicYear: "2024",
      Semester: "I",
      Status: "Absent",
      Change: "Absent",
    },
    {
      Sno: 6,
      Date: "2025-06-29",
      Name: "RAVI KUMAR",
      ParticipantType: "SCHOOL TEACHERS",
      ParticipantTier: "PGT CS",
      CourseGroup: "ML",
      BatchNo: "A",
      AdmnNo: "2506240022",
      AcademicYear: "2024",
      Semester: "I",
      Status: "Present",
      Change: "Present",
    },
    {
      Sno: 7,
      Date: "2025-06-30",
      Name: "RAVI KUMAR",
      ParticipantType: "SCHOOL TEACHERS",
      ParticipantTier: "PGT CS",
      CourseGroup: "ML",
      BatchNo: "A",
      AdmnNo: "2506240022",
      AcademicYear: "2024",
      Semester: "I",
      Status: "Absent",
      Change: "Absent",
    },
    {
      Sno: 8,
      Date: "2025-07-01",
      Name: "RAVI KUMAR",
      ParticipantType: "SCHOOL TEACHERS",
      ParticipantTier: "PGT CS",
      CourseGroup: "ML",
      BatchNo: "A",
      AdmnNo: "2506240022",
      AcademicYear: "2024",
      Semester: "I",
      Status: "Present",
      Change: "Present",
    },
    {
      Sno: 9,
      Date: "2025-07-02",
      Name: "RAVI KUMAR",
      ParticipantType: "SCHOOL TEACHERS",
      ParticipantTier: "PGT CS",
      CourseGroup: "ML",
      BatchNo: "A",
      AdmnNo: "2506240022",
      AcademicYear: "2024",
      Semester: "I",
      Status: "Present",
      Change: "Present",
    },
    {
      Sno: 10,
      Date: "2025-07-04",
      Name: "RAVI KUMAR",
      ParticipantType: "SCHOOL TEACHERS",
      ParticipantTier: "PGT CS",
      CourseGroup: "ML",
      BatchNo: "A",
      AdmnNo: "2506240022",
      AcademicYear: "2024",
      Semester: "I",
      Status: "Absent",
      Change: "Absent",
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Attendance</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Teacher</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Attendance
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Attendance List</h5>
                <div>
                  <button className="btn btn-primary">Save Attendance</button>
                </div>
              </div>
            </div>
            {/* <div className="card"> */}
            <Table dataSource={tableData} columns={columns} Selection={false} />
            {/* </div> */}
            <div>
              <button className="btn btn-primary mb-2">Save Attendance</button>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default ViewAttendance;
